import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ComponentDataSourceService } from '../../component-data-source.service';
import { DataSourceFunction } from '../../component-data-source.service';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { environment } from '../../../../environment/environment';

export interface EventOrgResourceItem {
  id: number;
  label: string;
  is_active?: boolean;
  sort_order?: number;
}

/** Active organization bookable resources for event forms (same call pattern as event_price_groups). */
export function event_org_resources(service: ComponentDataSourceService): DataSourceFunction {
  return {
    name: 'event_org_resources',
    description: 'Active org bookable resources for add/edit event forms',
    execute: (_params?: LoadDataParams): Observable<{ items: EventOrgResourceItem[]; totalCount: number }> => {
      const activeOnly = _params?.queryParams?.['activeOnly'] !== 'false';
      const requestParams: Record<string, string> = activeOnly ? { activeOnly: 'true' } : {};
      return service.http
        .get<{ items?: EventOrgResourceItem[]; totalCount?: number }>(
          `${environment.apiUrl}/events/org-resources`,
          { params: requestParams }
        )
        .pipe(
          map((res) => ({
            items: (res?.items ?? []) as EventOrgResourceItem[],
            totalCount: res?.totalCount ?? (res?.items?.length ?? 0),
          })),
          catchError((error) => {
            console.error('[event_org_resources datasource] Error:', error);
            return of({ items: [], totalCount: 0 });
          })
        );
    },
  };
}
